import React from 'react';
import { DirectionsCar, Train, DirectionsBus, Commute } from '@mui/icons-material';

export const umrahTransportOptions = [
  { value: 'Private Car', label: 'Private car', icon: <DirectionsCar />, detail: 'Door-to-door with driver' },
  { value: 'High-Speed Train', label: 'High-speed train', icon: <Train />, detail: 'Fast Makkah - Madina' },
  { value: 'Luxury Bus', label: 'Luxury bus', icon: <DirectionsBus />, detail: 'Comfortable for groups' },
];

export const leisureTransportOptions = [
  { value: 'Private Car', label: 'Private car', icon: <DirectionsCar />, detail: 'Airport and city transfers with driver' },
  { value: 'Shared Transfer', label: 'Shared transfer', icon: <DirectionsBus />, detail: 'Budget-friendly group rides' },
  { value: 'Self Drive', label: 'Self drive', icon: <Commute />, detail: 'Rental arranged - pick your vehicle class' },
];

export const ziaraatOptions = [
  { value: 'Standard', label: 'Standard Ziaraat', city: 'Makkah and Madina' },
  { value: 'Premium', label: 'Premium Ziaraat', city: 'Makkah and Madina' },
  { value: 'Private', label: 'Private Ziaraat', city: 'Dedicated guide and vehicle' },
];

export const carRentalClasses = ['Economy', 'Sedan', 'SUV', 'Van'];